import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {PearlHarbor} from "../../PearlHarbor";
import {ISplitData} from "../../server/PearlHarborModel";
import {PearlHarborSplitSymbol} from "../../reels/PearlHarborSplitSymbol";

export class PearlHarborRestoreXSWinRunner implements SimplePresentationRunner {

    shouldRun(): boolean {
        return PearlHarbor.model.xs.length > 0;
    }

    start(controller: SimplePresentationRunnerController): void {
        for (let n: number = 0; n < PearlHarbor.model.xs.length; n++) {
            const xSplits: ISplitData = PearlHarbor.model.xs[n],
                symPos: number[] = xSplits.symPos;
            (<PearlHarborSplitSymbol>PearlHarbor.allReelsView.mainReelModels[symPos[0]].getSymbolByTargetPosition(symPos[1]))!.playXSLandingAnim();
        }
        controller.finish();
    }
}